(function ($) {
  window.DGS.OnLoad.getInstance().register(function () {
    $('.component.event-calendar').each(function () {

      // window.DGS.EqualHeight.getInstance().register($('.fc-widget-content', $(this)), true);
    });
  });
})(jQuery);